<template>
  <!-- <div class="login-container"> -->
    <!-- <vue-pdf-app
      :pdf="url"
      page-scale='1000'
      ></vue-pdf-app
    > -->
    <!-- :page-scale="20" -->
    <div>
      <vue-pdf-app style="position: relative; height:100vh" :pdf="url" :page-scale="20">123</vue-pdf-app>
    </div>  
</template>

<script>
import VuePdfApp from "vue-pdf-app";
// import this to use default icons for buttons
// import "vue-pdf-app/dist/icons/main.css";
import "vue-pdf-app/dist/icons/main";

export default {
  components: {
    VuePdfApp,
  },
  //   components: { SocialSign },
  data() {
    return {
      url: "",
      id: "",
      studyModalitytitle: "",
      token:'',
    };
  },
  created() {
    console.log(this.GLOBAL.BASE_URL)
    this.id = this.$router.currentRoute.query.id;
    this.studyModalitytitle = this.$router.currentRoute.query.studyModalitytitle;
    console.log('this.$router.currentRoute.query.',this.$router.currentRoute.query.studyModalitytitle)
    this.pdfurlGet()
    // window.addEventListener('storage', this.afterQRScan)
  },
  methods: {
    pdfurlGet() {
      this.token = sessionStorage.getItem("token");
      this.url =  this.GLOBAL.BASE_URL + 'v1/report/exportReportByStudyId?' + 'token' + '=' + this.token + '&' + 'studyId' + '=' + this.id + '&' + 'typeEnums' + '=' + this.studyModalitytitle
      console.log(this.url);
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/pdfconentcopy/index.vue